const CONFIG = {
  SUB_DOMAIN_NAME: window.location.origin.includes("stg")
    ? "finwell-stg"
    : window.location.origin.includes("dev")
    ? "finwell-dev" 
    : window.location.origin.includes("demo")
    ? "finwell-demo"
    : "financialwellness.envision",
  DOMAIN_URL: window.location.origin.includes("stg")
    ? "https://finwell-stg.niit-mts.com/"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-dev.niit-mts.com/" //https://realtorsuccesslearning-dev-b2c.niit-mts.com/
    : window.location.origin.includes("demo")
    ? "https://finwell-demo.training.com/"
    : (window.location.origin.includes("uat"))
    ? "https://b2c-learner-uat.training.com/"
    : window.location.origin.includes("citizen-demo")
    ? "https://citizen-demo.training.com/"
    : window.location.origin.includes("ie-demo")
    ? "https://ie-demo.training.com/"
    : "https://financialwellness.envision.pwc.com/",
  IOS_PACKAGE_NAME: "com.niit.xceed",
  ANDROID_PACKAGE_NAME: "com.niit.xceed",
  API_URL: window.location.origin.includes("stg")
    ? "https://finwell-admin-stg.niit-mts.com/"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-admin-dev.niit-mts.com/"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://finwell-admin.training.com/"
    : "https://admin.workforcesolutions.training.com/",
  ROLEPLAY_SOCKET_URL: window.location.origin.includes("stg")
    ? "https://halifax-roleplay-server-stg.niit-mts.com/"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://b2c-roleplay-server-dev.niit-mts.com/"
    : window.location.origin.includes("citizen")
    ? "https://b2c-roleplay-server-uat.training.com/"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://b2c-roleplay-server-uat.training.com/"
    : "https://realtorsuccesslearning-prod-videosocket.niit-mts.com/",
  IN_BUCKET_URL:
    window.location.origin.includes("stg") ||
    window.location.origin.includes("local") ||
    window.location.origin.includes("192.168") ||
    window.location.origin.includes("dev") ||
    window.location.origin.includes("citizen") ||
    (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
      ? "https://lt-in.s3.amazonaws.com/stg"
      : "https://lt-in.s3.amazonaws.com/prod",
  OUT_BUCKET_URL:
    window.location.origin.includes("stg") ||
    window.location.origin.includes("local") ||
    window.location.origin.includes("192.168") ||
    window.location.origin.includes("dev") ||
    window.location.origin.includes("citizen") ||
    (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
      ? "https://cdn-stg.niit-mts.com"
      : "https://cdn.niit-mts.com",
  SCORM_URL: window.location.origin.includes("stg")
    ? "https://finwell-admin-stg.niit-mts.com/public/scorm_player"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-admin-dev.niit-mts.com/public/scorm_player"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://finwell-admin.training.com/public/scorm_player"
    : "https://admin.workforcesolutions.training.com/public/scorm_player",
  SCORM_URL_BROKER: window.location.origin.includes("stg")
    ? "https://finwell-orgadmin-stg.niit-mts.com/public/scorm_player.php"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-orgadmin-dev.niit-mts.com/public/scorm_player.php"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://finwell-orgadmin.training.com/public/scorm_player.php"
    : "https://admin.financialwellness.envision.pwc.com/public/scorm_player.php",
  //WOO commerse related variable
  API_URL_BROKER: window.location.origin.includes("stg")
    ? "https://finwell-ecom-stg.niit-mts.com"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-ecom-dev.niit-mts.com"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://finwell-ecom.training.com"
    : "https://ecom.workforcesolutions.training.com",
  API_URL_BROKER_ADMIN: window.location.origin.includes("stg")
    ? "https://finwell-orgadmin-stg.niit-mts.com"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-orgadmin-dev.niit-mts.com"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://finwell-orgadmin.training.com"
    : "https://admin.financialwellness.envision.pwc.com",
  SHOW_LIVE: window.location.origin.includes("stg")
    ? false
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? true
    : window.location.origin.includes("citizen")
    ? false
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? false
    : false,
  ROLEPLAY_PARTICIPANT_GUIDE: window.location.origin.includes("stg")
    ? "https://cdn-stg.niit-mts.com/xsel/resource/Roleplay_help-Participant_guide.pdf"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://cdn-stg.niit-mts.com/xsel/resource/Roleplay_help-Participant_guide.pdf"
    : window.location.origin.includes("citizen")
    ? "https://cdnstg.training.com/xsel/resource/Roleplay_help-Participant_guide.pdf"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://cdnstg.training.com/xsel/resource/Roleplay_help-Participant_guide.pdf"
    : "https://cdn.training.com/xsel/resource/Roleplay_help-Participant_guide.pdf",
  ROLEPLAY_COACH_GUIDE: window.location.origin.includes("stg")
    ? "https://cdn-stg.niit-mts.com/xsel/resource/Roleplay_help-Coach_guide.pdf"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://cdn-stg.niit-mts.com/xsel/resource/Roleplay_help-Coach_guide.pdf"
    : window.location.origin.includes("citizen")
    ? "https://cdnstg.training.com/xsel/resource/Roleplay_help-Coach_guide.pdf"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://cdnstg.training.com/xsel/resource/Roleplay_help-Coach_guide.pdf"
    : "https://cdn.training.com/xsel/resource/Roleplay_help-Coach_guide.pdf",
  API_URL_REAL_BROKER: window.location.origin.includes("stg")
    ? "https://finwell-orgadmin-stg.niit-mts.com/"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-orgadmin-dev.niit-mts.com/"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "https://finwell-orgadmin.training.com/"
    : "https://admin.financialwellness.envision.pwc.com/",
  KEY: {
    // STRIPE_KEY: 'pk_test_51L1VejSAhcjWU0OJxqVqHvGHAro5uMh6eUZGjClM2ak7iVAqktXc4k0F59RLYF7KbsKx6jYqigpjgJG9wdr4SgDz001WV3GMxC',
    STRIPE_KEY: window.location.origin.includes("stg")
      ? "pk_test_51M2YcSGYsyXzgi3mzaqBgWvsVyKbhHGvOYl1NlyrnmItUAUeKi1MQGspv0UtVs5YzjCewvARHubnCyBn3wriQ32u00TBFRM9Kw"
      : window.location.origin.includes("local") ||
        window.location.origin.includes("192.168") ||
        window.location.origin.includes("dev")
      ? "pk_test_51LA5wtF9C1JUoSzJVwn1JbK3wL9emcUTk5ISkt9d4sovOgPFjd5SueTMjDGiYMht5AcrK8YiGImJbGAOxr83Yc3000e2UleAAj"
      : window.location.origin.includes("citizen")
      ? "pk_test_51M2YdlEqoicc8qLgiPllPchRDCUrzRiTatBGHKlS4pFLbTgmnuB0JxwIVhSif5YGK6vhVarZIoLEdpqHeCuVWpsm00iG08YRwy"
      : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
      ? "pk_test_51M2YdlEqoicc8qLgiPllPchRDCUrzRiTatBGHKlS4pFLbTgmnuB0JxwIVhSif5YGK6vhVarZIoLEdpqHeCuVWpsm00iG08YRwy"
      : "pk_live_51M4ri2G1MnCffT1s1StLmIkl2AGZQViOdsEpjCFgwSZnG3CrooY7ftUYtZjzjCTTkZvKoXG0OuuNF2KfrfUJ8rzB00LSGidz52",
    MOBILE_ACCESS_KEY: "xsel_1SIEL3islIELABEI",
  },
  STRIPE_RETURN_URL: window.location.origin.includes("stg")
    ? "https://finwell-stg.niit-mts.com"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "https://finwell-dev.niit-mts.com"
    : window.location.origin.includes("citizen")
    ? "https://citizen-demo.training.com"
    : window.location.origin.includes("uat")
    ? "https://b2c-learner-uat.training.com"
    : "https://financialwellness.envision.pwc.com",
  COLOR_ELEMENT_1: "#415385",
  COLOR_ELEMENT_2: "#53389E",

  NEXT_RELEASE: window.location.origin.includes("stg")
    ? true
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev") ||
      (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? true
    : false,
  C21_BROKER_ID: window.location.origin.includes("stg")
    ? 690
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev") 
    ? 349
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo")) || window.location.origin.includes("citizen")
    ? 349
    : 3,
  PAGINATION_PAGE_SIZE: 12,
  THRESHOLD_FOR_HOST: 1,
  THRESHOLD_FOR_PARTICIPANT: 30,
  THRESHOLD_FOR_LIVE_BUTTON_ACTIVE: 900, // 15 mins * 60
  DEFAULT_AVATAR: "/images/avatar.svg",
  ENV: window.location.origin.includes("stg")
    ? "STG"
    : window.location.origin.includes("citizen")
    ? "UAT"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "UAT"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "DEV"
    : "PROD",
    

    SECRET_KEY: window.location.origin.includes("stg")
    ? "Zr8n7HL25NPM33Hx"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "rjvDeYOD3lsFReFB" 
    : window.location.origin.includes("citizen")
    ? "hcDnOuL52T963ydI"
    : (window.location.origin.includes("uat") || window.location.origin.includes("demo"))
    ? "hcDnOuL52T963ydI"
    : window.location.origin.includes("c21")
    ? "VYRMDiXZRpg5ZpM3"
    : "VYRMDiXZRpg5ZpM3",

  INITIAL_PRODUCT_CARD_DATA: [
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
  ],
  INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA: [
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
  ],

  INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_VIDEOS: [
    {
      tagsArray: [1, 2],
      isLoading: true,
    },
  ],
  INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_COURSES: [
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
  ],

  INITIAL_PRODUCT_CARD_DATA_FOR_ORDERS: [
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
  ],
};

export default CONFIG;
